<template>
  <div class="stocks-page">
    <!-- <PreloaderPage /> -->

    <BannerPages
      :title="'stocks.titleBanner'"
      :descriptions="[
        $t('stocks.descriptionBanner1'),
        $t('stocks.descriptionBanner2')
      ]"
      :img="'/images/stocks/stocks-img-banner.png'"
      mainImageWidthDesk="568"
      mainImageHeightDesk="550"
      alt="Trade real US stocks at Tradeview"
      :buttons="[
        {
          type: 'external',
          href: getExternalUrl('/register/1/live-account'),
          class: 'primary-button-medium',
          text: 'home.banner.button-1' 
        },
        {
          type: 'external',
          href: getExternalUrl('/register/1/demo-account'),
          class: 'second-button-medium-white',
          text: 'home.banner.button-2' 
        }
      ]"
    />

    <div class="margin-general forex_tradeview" :style="degrade">
      <div class="forex_tradeview_text">
        <h2>{{ $t("stocks.title_stocks_tradeview") }}</h2>
        <p class="body-4">{{ $t("stocks.desc_stocks_tradevie") }}</p>
        <p class="body-4 bold">
          {{ $t("stocks.desc2_stocks_tradeview") }}
        </p>
      </div>
      <LazyAccordeon :options="cards" />
    </div>

    <div class="margin-general find_forex">
      <div class="text">
        <h2>{{ $t("stocks.find_stocks_title") }}</h2>
        <p class="body-4 desc1">{{ $t("stocks.find_stocks_desc1") }}</p>
        <p class="body-4 bold desc2">{{ $t("stocks.find_stocks_desc2") }}</p>
      </div>
      <LazyTabsPlatforms :tabs="tabs" :categories="filteredCategories" />
    </div>

    <LazyPlatformSlider
      titleSection="forex.choosePlatformTitle"
      descriptionSection="forex.choosePlatformDesc"
      :cards="cardsPlatform"
      :slider="slider"
      :slidesPerView="1"
      :spaceBetween="30"
      className="slideForex"
    />

    <!-- <div class="margin-general pathMarket" :style="degrade2">
      <h2>{{ $t("stocks.choosePathTitle") }}</h2>
      <p class="body-4 desc1">{{ $t("stocks.choosePathDesc") }}</p>
      <LazyTableComponent :titleCards="titleCardsStocks" :cards="cardsStocks" />
      <div class="notes">
        <p>{{ $t("stocks.choosePathDesc1") }}</p>
        <p>{{ $t("stocks.choosePathDesc2") }}</p>
        <p>
          {{ $t("stocks.choosePathDesc3") }}
          <NuxtLink :to="localPath('/trading/accounts')"
            >{{ $t("stocks.here") }}.</NuxtLink
          >
        </p>
      </div>

      <div class="buttons">
        <a target="_blank" :href="getExternalUrl('/register/1/live-account')" class="primary-button-medium"
           rel="noopener noreferrer">
            {{ $t("stocks.button") }}
          </a
        >
      </div>
    </div> -->

    <div class="trading-Cond">
      <div>
        <h2 class="titleCond">{{ $t("stocks.tradinCondTitle") }}</h2>
        <p class="body-4">{{ $t("stocks.tradinCondDesc") }}</p>
      </div>
      <div class="flex">
        <div class="card">
          <div class="icon">
            <span class="material-symbols-outlined" translate="no">article</span>
          </div>
          <div>
            <p class="title">{{ $t("forex.trading_cond_title3") }}</p>
            <!-- <p class="subtitle">{{ $t("forex.trading_cond_desc3") }}</p> -->
            <a
              :href="localPath('/trading/markets/trading-conditions/order-types/')"
              rel="noopener noreferrer"
              target="_blank"
              >{{ $t("forex.trading_cond_link3") }}</a
            >
          </div>
        </div>
        <div class="card">
          <div class="icon">
            <span class="material-symbols-outlined" translate="no">alarm</span>
          </div>
          <div>
            <p class="title">{{ $t("forex.trading_cond_title4") }}</p>
            <!-- <p class="subtitle">{{ $t("forex.trading_cond_desc4") }}</p> -->
            <a
              :href="localPath('/trading/markets/trading-conditions/stocks-trading-hours/')"
              rel="noopener noreferrer"
              target="_blank"
              >{{ $t("forex.trading_cond_link4") }}</a
            >
          </div>
        </div>
      </div>
    </div>

    <LazyMoreResource
      :titleH2="'forms_and_documents.protectedTitle'"
      :cards="cardsSlideProtected"
      :padding="'padding-icon'"
      class="protected with-icons"
    />

    <client-only>
      <LazyInvestment
        :label="'stocks.ready'"
        :buttonConfigs="[
          {
            type: 'external',
            href: getExternalUrl('/register/1/live-account'),
            class: 'primary-button-medium',
            textKey: 'market.btn-invest'
          }
        ]"
      />
    </client-only>
  </div>
</template>

<script setup>
import LazyInvestment from "~/components/Investment";
import LazyAccordeon from "~/components/Accordeon";
import LazyTabsPlatforms from "~/components/forex/TabsPlatforms";
import LazyPlatformSlider from "~/components/forex/PlatformsSlider.vue";
import LazyMoreResource from "~/components/home/MoreResource";
import LazyTableComponent from "~/components/TableComponent";
// import PreloaderPage from "~/components/PreloaderPage.vue";
import { useI18n } from "vue-i18n";
import { useExternalUrl } from '@/composables/useExternalUrl';
import { useImage } from '#imports'; 

const { t, locale } = useI18n();
const { getExternalUrl } = useExternalUrl();
const { $regulationsVar } = useNuxtApp();

const regulation = ref($regulationsVar.getRegulation(locale.value));
const localPath = useLocalePath();
const nuxtImg = useImage();

const title = t("seo.stocks.title");
const description = t("seo.stocks.description");
const imgSeo = 'https://tradeview.eu/images/seo/18Stocks.jpg'

useSeoMeta({
  title: title,
  ogTitle: title,
  twitterTitle: title,
  description: description,
  ogDescription: description,
  twitterDescription: description,
  ogImage: imgSeo,
  twitterImage: imgSeo
});

const degradadeImageUrl = '/images/stocks/Stocks-Gradient-1.avif';
const degradade2ImageUrl = '/images/stocks/Stocks-Gradient-2.avif';

const optimizedDegrade = nuxtImg(degradadeImageUrl, {
  quality: 50,
  format: 'avif',
});
const optimizedDegrade2 = nuxtImg(degradade2ImageUrl , {
  quality: 50,
  format: 'avif',
});

const degrade = computed(() => {
  return {
    '--degrade': `url('${optimizedDegrade}')`,
  };
});

const degrade2 = computed(() => {
  return {
    '--degrade2': `url('${optimizedDegrade2}')`,
  };
});

let cards = ref([
  /* {
    title: "stocks.accordeonTitle1",
    texts: [
      'stocks.accordeonDesc1',
    ],
    icon: "monitoring",
  }, */
  {
    title: "stocks.accordeonTitle2",
    texts: [
      'stocks.accordeonDesc2',
    ],
    icon: "folder_open",
  },
  {
    title: "stocks.accordeonTitle3",
    texts: [
      'stocks.accordeonDesc3',
    ],
    icon: "support_agent",
  },
  {
    title: "stocks.accordeonTitle4",
    texts: [
      'stocks.accordeonDesc4',
    ],
    icon: "account_balance",
    image: "/images/meta_5.png",
    iconAlt: "",
  },
]);

let tabs = ref([
  { value: "equities", label: "stocks.equitiesT" },
  { value: "etfs", label: "stocks.etfsT" },
  /* { value: "options", label: "stocks.optionsT" }, */
]);

function filterItems(items) {
  return items.filter(item => !item.hideInLanguages?.includes(locale.value));
}

let categories = ref({
  equities: [
    {
      title: "stocks.equitiesTitle",
      description: "stocks.equitiesDesc",
      text: {
        title: "stocks.equitiesTitleTitle",
        desc: "stocks.equitiesDescText",
      },
      details: filterItems([
        {
          icon: "stacks",
          title: "stocks.equitiesTitle1",
          description: "stocks.equitiesDescr1",
        },
        {
          icon: "event_upcoming",
          title: "stocks.equitiesTitle3",
          description: "stocks.equitiesDescr3",
        },
        {
          icon: "newspaper",
          title: "stocks.equitiesTitle4",
          description: "stocks.equitiesDescr4",
        },
      ]),
    },
  ],
  etfs: [
    {
      title: "stocks.etfsTitle",
      description: "stocks.etfsDesc",
      text: {
        title: "stocks.etfsTitleTitle",
        desc: "stocks.etfsDescText",
      },
      details: filterItems([
        {
          icon: "chart_data",
          title: "stocks.etfsTitle1",
          description: "stocks.etfsDesc1",
        },
        {
          icon: "hub",
          title: "stocks.etfsTitle2",
          description: "stocks.etfsDesc2",
        },
        {
          icon: "shield",
          title: "stocks.etfsTitle3",
          description: "stocks.etfsDesc3",
        },
        {
          icon: "newspaper",
          title: "stocks.etfsTitle4",
          description: "stocks.etfsDesc4",
          hideInLanguages: ['es-mx']
        },
      ]),
    },
  ],
  /* options: [
    {
      title: "stocks.optionsTitle",
      description: "stocks.optionsDesc",
      text: {
        title: "stocks.optionsTitleTitle",
        desc: "stocks.optionsDescText",
      },
      details: filterItems([
        {
          icon: "fork_right",
          title: "stocks.optionsTitle1",
          description: "stocks.optionsDesc1",
        },
        {
          icon: "page_info",
          title: "stocks.optionsTitle3",
          description: "stocks.optionsDesc3",
        },
        {
          icon: "flag",
          title: "stocks.optionsTitle4",
          description: "stocks.optionsDesc4",
        },
      ]),
    },
  ], */
});

let filteredCategories = computed(() => {
  return Object.fromEntries(
    Object.entries(categories.value).map(([key, value]) => {
      return [key, value.map(category => ({
        ...category,
        details: filterItems(category.details),
      }))];
    })
  );
});

let cardsPlatform = ref([
  {
    name: "stocks.mt5",
    description: "MetaTrader 5",
  },
  /* {
    name: "stocks.Sterling",
    description: "Sterling",
  },
  {
    name: "stocks.Lightspeed",
    description: "Lightspeed",
  },
  {
    name: "stocks.Takion",
    description: "Takion",
  },
  {
    name: "stocks.DAS",
    description: "DAS",
  },
  {
    name: "stocks.API/FIX",
    description: "API/FIX",
  }, */
]);

let slider = ref([
  {
    imgBackground: "/images/stocks/mt5.png",
    title: "stocks.mt5",
    description: [
      "stocks.metatrader5Desc1",
      "stocks.metatrader5Desc2",
      "stocks.metatrader5Desc3",
      "stocks.metatrader5Desc4",
      "stocks.metatrader5Desc5",
    ],
    icon: "/images/stocks/MT5-Icon.svg",
    alt: "Trade Stocks on MT5",
  },
  /* {
    imgBackground: "/images/stocks/sterling.png",
    title: "stocks.Sterling",
    description: [
      "stocks.sterlingDesc1",
      "stocks.sterlingDesc2",
      "stocks.sterlingDesc3",
      "stocks.sterlingDesc4",
      "stocks.sterlingDesc5",
    ],
    icon: "/images/stocks/Sterling-Icon.svg",
    alt: "Trade Stocks on Sterling",
  }, */
  /* {
    imgBackground: "/images/stocks/lightspeed.png",
    title: "stocks.Lightspeed",
    description: [
      "stocks.lightspeedDesc1",
      "stocks.lightspeedDesc2",
      "stocks.lightspeedDesc3",
      "stocks.lightspeedDesc4",
      "stocks.lightspeedDesc5",
    ],
    icon: "/images/stocks/Lightspeed-Icon.svg",
    alt: "Lightspeed Trading",
  }, */
 /*  {
    imgBackground: "/images/stocks/takion.png",
    title: "stocks.Takion",
    description: [
      "stocks.tokionDesc1",
      "stocks.tokionDesc2",
      "stocks.tokionDesc3",
      "stocks.tokionDesc4",
      "stocks.tokionDesc5",
    ],
    icon: "/images/stocks/Takion-Icon.svg",
    alt: "Trade Stocks on Takion",
  }, */
  /* {
    imgBackground: "/images/stocks/das.png",
    title: "stocks.DAS",
    description: [
      "stocks.dasDesc1",
      "stocks.dasDesc2",
      "stocks.dasDesc3",
      "stocks.dasDesc4",
      "stocks.dasDesc5",
    ],
    icon: "/images/stocks/Das-Icon.svg",
    alt: "Das Trader Icon",
  }, */
  /* {
    imgBackground: "/images/stocks/apiFix.png",
    title: "stocks.API/FIX",
    description: [
      "stocks.apiDesc1",
      "stocks.apiDesc2",
      "stocks.apiDesc3",
      "stocks.apiDesc4",
      "stocks.apiDesc5",
    ],
    icon: "/images/stocks/API-FIX-Icon.svg",
    alt: "Trade Stocks on API",
  }, */
]);

let cardsSlideProtected = ref([
  // {
  //   icon: "sync",
  //   title: "forms_and_documents.protectedCardTitle1-1",
  //   desc: "forms_and_documents.protectedCardDesc1-1",
  // },
  {
    icon: "account_balance_wallet",
    title: "forms_and_documents.protectedCardTitle2",
    desc: "forms_and_documents.protectedCardDesc2",
  },
  {
    icon: "lock",
    title: "forms_and_documents.protectedCardTitle3",
    desc: "forms_and_documents.protectedCardDesc3",
  },
  {
    icon: "acute",
    title: "forms_and_documents.protectedCardTitle4",
    desc: "forms_and_documents.protectedCardDesc4",
  },
]);


let titleCardsStocks = ref({
  title: [
    { text: "" },
    { text: "accounts.tabsAccounts.stocks.cards.column2-title" },
    { text: "accounts.tabsAccounts.stocks.cards.column3-title" },
    { text: "accounts.tabsAccounts.stocks.cards.column4-title" },
    { text: "accounts.tabsAccounts.stocks.cards.column5-title" },
    { text: "accounts.tabsAccounts.stocks.cards.column6-title" },
  ],
});

let cardsStocks = ref([
  {
    title: " ",
    items: [
      { column1: "accounts.tabsAccounts.stocks.cards.column1-it1" },
      { column1: "accounts.tabsAccounts.stocks.cards.column2-it1" },
      { column1: "accounts.tabsAccounts.stocks.cards.column3-it1" },
      { column1: "accounts.tabsAccounts.stocks.cards.column4-it1" },
      { column1: "accounts.tabsAccounts.stocks.cards.column5-it1" },
      { column1: "accounts.tabsAccounts.stocks.cards.column6-it1" },
    ],
  },
  {
    title: "accounts.tabsAccounts.stocks.cards.column2-title",
    items: [
      { column1: "accounts.tabsAccounts.stocks.cards.column1-it2" },
      { column1: "accounts.tabsAccounts.stocks.cards.column2-it2" },
      { column1: "accounts.tabsAccounts.stocks.cards.column3-it2" },
      { column1: "accounts.tabsAccounts.stocks.cards.column4-it2" },
      { column1: "accounts.tabsAccounts.stocks.cards.column5-it2" },
      { column1: "accounts.tabsAccounts.stocks.cards.column6-it2" },
    ],
  },
  {
    title: "accounts.tabsAccounts.stocks.cards.column3-title",
    items: [
      { column1: "accounts.tabsAccounts.stocks.cards.column1-it3" },
      { column1: "accounts.tabsAccounts.stocks.cards.column2-it3" },
      { column1: "accounts.tabsAccounts.stocks.cards.column3-it3" },
      { column1: "accounts.tabsAccounts.stocks.cards.column4-it3" },
      { column1: "accounts.tabsAccounts.stocks.cards.column5-it3" },
      { column1: "accounts.tabsAccounts.stocks.cards.column6-it3" },
    ],
  },
]);
</script>